export default __webpack_public_path__ + "media/images/favicon-b7ff90356a4d43861b46eb3183dbb0d3.svg";